import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { DataTablesResponse } from '../../../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../environments/environment';
import { ValidationService } from '../../../../shared/providers/validation.service';

@Component({
    selector: 'app-shared-user-list',
    templateUrl: './shared-user-list.component.html',
    styleUrls: ['./shared-user-list.component.css']
})
export class SharedUserListComponent implements OnInit {

    constructor(private http: HttpClient, private modalService: BsModalService, private Validation: ValidationService) {

    }
    dtOptions = {};
    table: DataTableDirective;
    @ViewChild(DataTableDirective) dtElement: DataTableDirective;
    protected readonly BASE_URL: string = environment.base_url;
    @Input() modalRef: BsModalRef;
    @Input() userRoles: string;
    @Input() selectedUserId = [];
    @Output() selectedUserEvent = new EventEmitter();
    userRoleToSort = '';
    users :any;
    searchValue='';
    ngOnInit() {

        if (this.userRoles == 'seller') {
            this.userRoleToSort = 'Seller';
        }
        if (this.userRoles == 'broker') {
            this.userRoleToSort = 'Broker';
        }

        const filter = {};
      
        const that = this;
        let TableColums =
            [{ data: 'ID' }];
        this.dtOptions = {
            pagingType: 'full_numbers',
            serverSide: true,
            processing: true,
            info: false,
            language: {
                zeroRecords: null,
            },
            "pageLength": 10,
            bLengthChange: false,
            initComplete: () => $('.dataTables_filter').css('display', 'none'),
            ajax: (dataTablesParameters: any, callback: Function) => {
                dataTablesParameters.Extra_param = filter;
                if (this.userRoles == 'broker') {
                    dataTablesParameters.Extra_param.Type = 4;
                }
                else if (this.userRoleToSort == 'Seller') {
                    dataTablesParameters.Extra_param.Type = 13;
                }
                dataTablesParameters.Extra_param.ExcludeId = this.selectedUserId;
                const httpHeader = this.Validation.GetAuthHeader();
                that.http
                    .post<DataTablesResponse>(
                        this.BASE_URL + '/user/principals/',
                        dataTablesParameters, httpHeader
                    ).subscribe(resp => {
                        $("#dtTable thead").hide();
                        that.users = resp.data ? resp.data : [];
                        if (resp) {
                            callback({
                                recordsTotal: resp.recordsTotal,
                                recordsFiltered: resp.recordsFiltered,
                                data: []
                            });
                            if (resp.data.length === 0) {
                                $(".dataTables_paginate.paging_full_numbers").hide();
                            }
                            else {
                                $(".dataTables_paginate.paging_full_numbers").show();
                            }
                            $(".paginate_button.first,.paginate_button.last").hide();
                        } else {
                            callback({
                                recordsTotal: 0,
                                recordsFiltered: 0,
                                data: []
                            });
                            $(".dataTables_paginate.paging_full_numbers").hide();
                        }
                    });
            },
            columns: TableColums
        };
    }
    onSearch(text: string) {
        this.dtElement.dtInstance.then(x => x.search(text).draw());
    }

    onUserSelect(user: any) {
        this.modalRef.hide();
        this.selectedUserEvent.emit(user);
    }
}
